/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Make sure this isn't imported in the analytics worker
 *	> 'owa-feature-flags' import is restricted from being used. Feature flags have to be passed in the analytics worker initialization [analytics-worker-lint] */
import { isFeatureEnabled } from 'owa-feature-flags';
import type {
    ApplicationSettings,
    ApplicationSettingGroup,
} from '../store/schema/ApplicationSettings';
import getStore from '../store/store';
import { raiseAlertForDefaultSettings } from '../utils/allowDefaultApplicationSettings';
import type { MailboxInfo } from 'owa-client-types';

function updateSettingsWithOverrides(
    settings: Record<string, any>,
    overrides: Record<string, any>,
    path: any
) {
    let result = {};

    Object.keys(settings).forEach(setting => {
        const isGroup = typeof setting === 'object' && setting !== null && !Array.isArray(setting);

        if (isGroup) {
            result = {
                ...result,
                [path.shift()]: updateSettingsWithOverrides(settings[setting], overrides, path),
            };
        } else {
            const settingPath = [...path, setting].join('.');
            const override = overrides[settingPath];
            result = {
                ...result,
                [setting]: override === undefined ? settings[setting] : override,
            };
        }
    });

    return result;
}

export default function getApplicationSettings<TGroup extends ApplicationSettingGroup>(
    group: TGroup,
    mailboxInfo?: MailboxInfo
): ApplicationSettings[TGroup] {
    const store = getStore(mailboxInfo);
    if (!store.initialized && !process.env.JEST_WORKER_ID) {
        raiseAlertForDefaultSettings(mailboxInfo, group);
    }

    if (isFeatureEnabled('fwk-devTools')) {
        return updateSettingsWithOverrides(store.settings[group], store.overrides, [group]) as any;
    }

    return store.settings[group];
}
